export default "__VITE_ASSET__7a463fb9__"